import React from 'react';
import { Icon } from './Icon.js';
export const IconShapePolygonFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m7.235.935c-.727-.584-1.743-.584-2.47,0h0L1.241,3.764c-.6.482-.868,1.277-.682,2.026l1.048,4.209c.22.884,1.009,1.501,1.917,1.501h4.951c.908,0,1.697-.617,1.917-1.501l1.048-4.208c.187-.748-.081-1.543-.682-2.026L7.235.935Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconShapePolygonFill12.js.map